<template>
	<header id="masthead" class="site-header" :class="scrollTop > 200" ref="header">
		<div class="container-fluid">
			<div class="site-header__container">
				<div class="site-header__branding">
					<router-link class="site-header__logo" :to="{ name: checkPermissions() ? 'CustomersAgent' : 'LandingPage' }">
						<img class="site-header__logo-img" src="@/assets/images/logo.png" alt="Logo" title="">
					</router-link>
				</div>
				<div class="site-header__nav-outer" ref="menu" :class="menuOpen ? classActive : ''">
				<div class="site-header-overlay" ref="overlay" @click="closeMenu" :class="menuOpen ? classActive : ''"></div>
					<div class="site-header__nav-inner">
						<MainNavigation @linkIsClicked="linkIsClicked"/>
					</div>
				</div>
			</div>
		</div>

		<ul class="site-nav__list-user" v-if="appendUserItems">
			<div class="site-nav-admin__overlay" ref="overlayNavigation" @click="closeDropdown"></div>
			<template v-if="loggedIn">
				<!-- Admin link -->
				<li class="site-nav__item site-nav__item--dropdown" @click="toggle" v-on-click-outside="closeDropdown">
					<a class="site-nav__link" ref="nav-link" href="javascript:;">
						<transition name="fade-in">
							<img v-if="user.photo" :src="user.photo" alt="Login image" class="site-nav-admin__img">
							<img v-else src="@/assets/images/__demo/profile/profile-placeholder.jpg" alt="Login image" class="site-nav-admin__img">
						</transition>
						<a class="site-nav__link user-name">
							Welcome, {{ user.first_name }} {{ user.last_name }}
						</a>
						<SvgIcon
							class="ico-angle-down"
							iconName="ico-angle-down"
							:class="{'chevron-active' : agentLinksData.isOpened, 'chevron-inactive' : !agentLinksData.isOpened}"
						/>
					</a>
					<!-- Links from state -->
					<MainNavigationLinks
						:data="agentLinksData"
					/>
				</li>
			</template>

			<!-- Login link -->
			<li class="site-nav__item" v-else>
				<SvgIcon
					class="site-nav__item-icon"
					iconName="ico-admin"
				/>
				<router-link class="site-nav__link" ref="nav-link" to="/login">
					Login
				</router-link>
			</li>
		</ul>

		<PartHamburger
			v-if="showHamburger"
			ref="hamburger"
			class="site-header__hamburger"
			:isActive="menuOpen"
			:onClick="toggleMenu"
		/>
	</header>
</template>

<script>
import PartHamburger from '../parts/PartHamburger';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import MainNavigation from './MainNavigation/MainNavigation';
import { domQueryAll, slideToggle } from '@/config/util';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import MainNavigationLinks from '@/components/main/MainNavigation/MainNavigationLinks';
import { check } from '@/services/RouteGuards/SuperAdmin';

export default {
	components: {
		PartHamburger,
		MainNavigation,
		MainNavigationLinks,
		SvgIcon
	},

	data () {
		return {
			showHamburger: false,
			menuOpen: false,
			innerWidth: 0,
			scrollTop: 0,
			classActive: 'is-active',
			// classSticky: 'is-sticky',
			classScroll: 'prevent-scroll',
			agentLinksData: {
				links: [],
				isOpened: false
			},
			appendUserItems: false
		};
	},

	computed: {
		menuItems () {
			return this.$store.getters['menus/getMenuItems'];
		},
		agentItems() {
			return this.$store.getters.getAgentItems;
		},
		adminItems() {
			return this.$store.getters.getAdminItems;
		},
		superItems() {
			return this.$store.getters.getSuperItems;
		},
		loggedIn() {
			return this.$store.getters.getLoggedIn;
		},
		user() {
			return this.$store.getters.getUser;
		}
	},
	mounted() {
		if (this.user.role === 'admin') {
			this.agentLinksData.links = this.adminItems;
		} else if (this.user.role === 'super_admin') {
			this.agentLinksData.links = this.superItems;
		} else {
			this.agentLinksData.links = this.agentItems;
		}
	},
	mixins: [onClickOutside],
	methods: {
		checkPermissions() {
			return check();
		},
		closeDropdown() {
			if (this.agentLinksData.isOpened === true) {
				this.agentLinksData.isOpened = false;
				this.$refs.overlayNavigation.classList.remove('showOverlay');
			}
		},
		toggle() {
			this.agentLinksData.isOpened = !this.agentLinksData.isOpened;
			if (this.agentLinksData.isOpened === true) {
				this.$refs.overlayNavigation.classList.add('showOverlay');
			} else {
				this.$refs.overlayNavigation.classList.remove('showOverlay');
			}
		},
		linkIsClicked() {
			if (this.menuOpen === true) {
				this.menuOpen = false;
				this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
			}
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		closeMenu() {
			if (this.menuOpen === true) {
				this.menuOpen = false;
			}
		},
		handleResize () {
			this.innerWidth = window.innerWidth;
		},
		toggleMenu () {
			let timeout;
			const slNavIcon = '.js-nav-icon';
			const slSubNav = '.js-subnav';

			this.menuOpen = !this.menuOpen;

			if (!this.menuOpen) {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					domQueryAll(slSubNav, this.$refs.header, el => {
						el.parentNode.querySelector(slNavIcon).classList.remove(this.classActive);
						slideToggle.slideUp(el, { duration: 10 });
					});
				}, 300);
				this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
			}

			if (this.menuOpen) {
				this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
			}
		},
		setScrollTop() {
			this.scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
		}
	},

	watch: {
		innerWidth (newWidth) {
			this.showHamburger = newWidth < 1200;
			this.appendUserItems = newWidth < 1200;
		}
	},

	beforeMount () {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.setScrollTop);

		this.handleResize();
		this.setScrollTop();
	},

	destroyed () {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('scroll', this.setScrollTop);
	}
};
</script>

<style lang="scss" scoped>
.site-nav-admin__overlay {
	position: fixed;
    top: 0;
    left: 0;
	bottom: 0;
	right: 0;
    width: 100%;
    height: 100vh !important;
    z-index: 1101;
    background-color: transparent;
	transition: $dur $ease;
	display: none;

	&.showOverlay {
		display: block;
	}
}

.site-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 15px;
	background-color: $selago;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 84px;
	z-index: 9999999999;
	transition: $dur / 2 $ease;
	will-change: transform;

	@include mq($sm) {
		padding: 0;
	}

	.container {
		@include mq($xl) {
			margin: 0;
		}
	}

	div {
		height: 100%;

		@include mq($xl) {
			height: auto;
		}
	}

	&.is-sticky {
		height: 60px;
		transition: $dur $ease;
		box-shadow: 0 0 12px -5px $black;

		.site-header__branding {
			transform: scale(0.8);
			transform-origin: center;
		}
	}

	@include mq($xl) {
		height: 60px;
	}

	.site-header-overlay {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba($white, 0.7);
		z-index: 1010;
		opacity: 0;
		visibility: hidden;
		pointer-events: none;
		transition: $dur $ease;

		&.is-active {
			opacity: 1;
			visibility: visible;
			pointer-events: all;
		}
	}

}

.site-header__container {
	display: flex;
	align-items: center;
	width: 100%;
}

.site-header__branding {
	display: flex;
	align-items: center;
	padding-right: 17px;
	cursor: pointer;
	transition: $dur $ease;

	@include mq($xl) {
		margin-left: 0;
	}
}

.site-header__logo {
	color: $white;
	display: block;
	width: 117px;

	@include mq($xl) {
		width: 95px;
	}

	@include mq($md) {
		width: 70px;
	}
}

.site-header__logo-img {
	display: block;
	width: 100%;
}

.site-header__nav-outer {
	width: 100%;
	@include mq($xl) {
		position: fixed;
		left: 0;
		top: 0;
		height: 100vh !important;//sass-lint:disable-line no-important
		width: 100vw;
		z-index: 1010;
		visibility: hidden;
		transition: $dur $ease $dur;
		will-change: transform;

		&.is-active {
			visibility: visible;
			transition: $dur $ease;

			&::before {
				opacity: 1;
				visibility: visible;
			}
		}
	}
}

.site-header__nav-inner {
	@include mq($xl) {
		position: absolute;
		right: 0;
		top: 0;
		width: 300px;
		height: 100% !important;//sass-lint:disable-line no-important
		background-color: $white-lilac;
		display: block;
		padding: 50px 0 40px;
		z-index: 1011;
		transform: translateX(100%);
		//transition: $dur $ease;

		.is-active & {
			transform: translateX(0);
		}
	}
}

.site-header__hamburger {
	@include mq($xl) {
		right: 15px;
		@include center(y);
		z-index: 1100;
	}
}

//user
.site-nav__list-user {
	@include mq($xl) {
		padding-right: 50px;
		margin: 0;
	}

	@include mq($sm) {
		padding-right: 70px;
	}

	.site-nav__item {
		padding: 14px 16px;
		transition: $dur $ease;
		display: flex;
		border-radius: 14px;

		@include mq($xl) {
			width: 100%;
			padding: 25px 20px;
			border-radius: 0;
		}

		&::after {
			display: none;
		}

		&:first-of-type {
			padding: 0 13px;

			&::before {
				display: none;
			}

			.site-nav__item-icon {
				font-size: 21px;
				padding-right: 14px;

				@include mq($xl) {
					padding-right: 12px;
					font-size: 18px;
				}
			}
		}

		&:nth-child(2) {
			@include mq($xl) {
				order: 3;

				.site-nav__item-icon {
					padding-right: 0;
					padding-left: 30px;
				}
			}
		}

		&:last-of-type {
			padding-left: 8px;
			margin-left: 22px;
			padding-right: 0;

			@include mq($xl) {
				padding-bottom: 23px;
				padding-left: 0;
				margin-left: 0;
				order: 2;
			}

			.site-nav__link,
			.site-nav__item-icon {
				color: $dodger-blue;

				@include mq($xl) {
					color: $fiord;
				}
			}

			@include hover {
				.site-nav__link,
				.site-nav__item-icon {
					color: $shuttle-gray;
				}
			}

			.site-nav__item-icon {
				padding-right: 12px;
			}
		}

		.site-nav__link {
			font-family: $font-main;
			font-weight: 500;
			font-size: 14px;
			padding-left: 6px;

			@include mq($xl) {
				font-weight: normal;
				font-size: 16px;
				display: flex;
				align-items: center;

				&.user-name {
					display: none;
				}
			}
		}
	}
}

.site-nav__item {
	position: relative;
	display: flex;
	position: relative;
	//height: 100%;
	align-items: center;
	transition: $dur $ease;
	padding: 14px 16px;
	border-radius: 14px;

	&:first-of-type {
		&::before {
			content: '';
			position: absolute;
			height: 100%;
			width: 1px;
			background-color: $grey-light;
			left: 0;
			top: 0;
			z-index: 2;
		}
	}

	&:nth-child(2) {
		.site-nav__item-icon {
			font-size: 19px;
		}
	}

	&::after {
		content: '';
		position: absolute;
		height: 100%;
		width: 1px;
		background-color: $grey-light;
		right: 0;
		top: 0;
		z-index: 2;
	}

	@include mq($xl + 1, 'min') {

		&.has-sub-menu {
			padding-right: 20px;
		}
	}

	@include mq($xl) {
		margin: 0;
		padding: 25px 20px;
		border-radius: 0;
		padding-left: 30px;
		border-bottom: 1px solid rgba( #9e9e9e, .3);
		overflow: hidden;
		transition: $dur $ease;
	}

	@include hover {
		cursor: pointer;
		background-color: $link-water;

		.site-nav__link--no-hover {
			color: $shuttle-gray;

			.site-nav__item-icon {
				color: $shuttle-gray;
			}
		}

		.ico-angle-down {
			color: $shuttle-gray;
		}

		.site-nav__item-icon {
			color: $dodger-blue;
		}

		/deep/ {
			> .site-subnav__list {
				transform: translateY(0);
				opacity: 1;
				visibility: visible;
			}
		}
	}

	&.site-nav__item--dropdown {
		@include mq($xl) {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			padding-bottom: 0 !important;
			border-bottom: none;
		}

		@include hover {
			background-color: none;
		}
	}
}

.site-nav-admin__img {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	object-fit: cover;

	@include mq($md) {
		width: 30px;
		height: 30px;
	}
}

.ico-angle-down {
    padding-right: 6px;
	color: $shuttle-gray;
	transition: $dur $ease;
	font-size: 12px;
    padding-left: 11px;
}

.chevron-active {
	transform: rotateX(180deg);
	will-change: transform;
}
</style>
